/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
//= require 'v4/boq_editor/editor_utils'

window.BidEditor = {
  _autoSaveInterval: null,

  _saveBidEditor() {
    const saveStatus = this._sendEditorDataToSave(
      {
        bid_items: {
          new_items: BidTree._getMappedNewBidNodes(),
          edit_items: BidTree._getMappedEditedBidNodes()
        },
        bid_modifications: {
          delete_items: BidTree._getMappedDeletedBidModificationNodes(),
          edit_items: BidTree._getMappedEditedBidModificationNodes(),
          new_items: BidTree._getMappedNewBidModificationNodes()
        },
        update_unit_price: BidTree._getMappedUpdateUnitPriceNodes()
      },
      $('#bid_items_save_url').val()
    );

    if (saveStatus[1].success) {
      _.each(saveStatus[1].success.new_bid_item_ids, function (value, key) {
        const node = BidTree._gridOptions.api.getRowNode(key);
        if (node) {
          node.data.bid_item_id = value;
          return BidTree._gridOptions.api.redrawRows({ rowNodes: [node] });
        }
      });

      _.each(saveStatus[1].success.new_bid_modification_ids, function (value, key) {
        const nodeArray = $.grep(BidTree._newBidModificationNodes, e => e.data.group.join('-') === key);
        if (nodeArray.length > 0) {
          nodeArray[0].data.id = value;
          return BidTree._gridOptions.api.redrawRows({ rowNodes: nodeArray });
        }
      });
    }

    if (saveStatus[0]) {
      BidTree._newBidNodes = [];
      BidTree._editedBidNodes = [];
      BidTree._newBidModificationNodes = [];
      BidTree._editedBidModificationNodes = [];
      BidTree._deletedBidModificationNodes = [];
      return BidTree._updateUnitPriceNodes = [];
    }
  },


  _parseSaveResponse(message) {
    const jsonResponse = JSON.parse(message);
    const flashMessage = this._getFlashContainer();
    flashMessage.show();

    BidTree.clearErrors();

    if (jsonResponse.errors) {
      flashMessage.attr('class', 'alert-box alert');
      flashMessage.html(I18n.t("errors.0004") + '<a href="javascript:;" class="close">&times;</a>');

      _.each(jsonResponse.errors, (value, key) => BidTree.markErrors({ rowId: key, errors: value }));
      return false;
    }

    flashMessage.attr('class', 'alert-box success');
    flashMessage.html(I18n.t("flash.bid_item.save.successfully") + '<a href="javascript:;" class="close">&times;</a>');
    this._flashTimeOut();
    return true;
  },

  _resize() {
    return setTimeout(() => {
      return BidTree._gridOptions.api.sizeColumnsToFit();
    });
  },

  initialize() {
    this._resize();
    $(window).resize(() => this._resize());
    $('.collapse-sidebar').click(() => this._resize());

    this._setupAutoSave();
    return $('#save').on('click', e => {
      BidTree._gridOptions.api.stopEditing();
      e.preventDefault();
      $("#save").addClass("disabled");
      return setTimeout(_.bind(this._saveBidEditor, this), 100);
    });
  },

  _autoSave() {
    if ($('#auto_save').first().is(':checked')) {
      BidTree._gridOptions.api.stopEditing();
      return this._saveBidEditor();
    }
  }
};

if (window.EditorUtils) _.extend(BidEditor, window.EditorUtils);
